import React from 'react';
// ======================== Small function ======================== //
export const ucFirst = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
export const getParamsByKey = (params, key) => {
    return params.get(key)?.split(',');
};
export function isForwardRefComponent(component) {
    // @ts-ignore
    return component?.$$typeof === Symbol.for('react.forward_ref');
}
export function isForwardRefChild(child) {
    if (!child)
        return false;
    if (React.isValidElement(child)) {
        // @ts-ignore
        return child.type?.$$typeof === React.forwardRef(() => null).$$typeof;
    }
    return child?.$$typeof === React.forwardRef(() => null).$$typeof;
}
export const numToLocalString = (num) => {
    if (typeof num === 'string') {
        const parsedNum = Number(num);
        return !isNaN(parsedNum) ? parsedNum.toLocaleString() : undefined;
    }
    else if (typeof num === 'number') {
        return num.toLocaleString();
    }
    return undefined;
};
export const handlePriceCheckFunc = (price, currency = null) => {
    let val;
    // Handle price parsing
    val = price
        ? typeof price === 'string'
            ? price.split('-').map((p) => (isNaN(Number(p)) ? p : Number(p)))
            : price
        : null;
    // Case 1: price is a number and currency is provided
    if (typeof price === 'number' && currency) {
        return `${numToLocalString(price)} ${currency}`;
    }
    // Case 2: price is a range (array with more than one element)
    if (Array.isArray(val) && val.length > 1) {
        return `${numToLocalString(val[0])} ${currency} - ${numToLocalString(val[1])} ${currency}`;
    }
    // Case 3: price is a single number
    if (typeof price === 'number') {
        return numToLocalString(price);
    }
    // Case 4: price is an invalid object (not a valid range or string)
    if (Array.isArray(price)) {
        return false;
    }
    // Case 5: Default case for single value or null
    return `${numToLocalString(Array.isArray(val) ? val[0] : val)} ${currency}`;
};
export const isNumeric = (value) => !isNaN(value) && !isNaN(parseFloat(value));
export const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func(...args);
        }, delay);
    };
};
export const cleanObject = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== null &&
        value !== undefined &&
        value !== '' &&
        !(Array.isArray(value) && value.length === 0) &&
        !(typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)));
};
//# sourceMappingURL=helpers.js.map